import { Observable, Subject } from 'rxjs';

export class ConfirmationAction {
	icon?: string;
	label?: string;
	cssClass?: string;
	type?: string; // Si link, le bouton est sous forme de lien
	_onClick: Subject<void> = new Subject<void>();

	constructor(label?: string, type?: string, cssClass?: string, icon?: string) {
		this.label = label;
		this.cssClass = cssClass;
		this.icon = icon;
		this.type = type;
	}

	/**
	 * On passe par un getter pour ne pas que l'on puisse appeler autre chose que subscribe sauf avec _onClick
	 */
	get onClick(): Observable<void>{
		return this._onClick.asObservable();
	}
}
